<template lang="pug">
div
  div.mt-2.metadata_fields(v-if="showTags")
    span(v-for="(value, index) in tagValues" :class="label_class(value)"
      :key="index")
        | {{value.label | titleize_label}}
  p.mb-0.mt-2(v-if="vocesText || themineConceptsData.length > 0 || indicePathData.length > 0")
    template(v-if="vocesText")
      span
        strong {{t("components.documents.metadata.voces")}}
        | {{ vocesText }}
    template(v-if="themineConceptsData.length > 0")
      template(v-for="(item, index) in themineConceptsData")
        span {{ item }}
        span.mx-1(v-if="!lastConcept(index)") |
    template(v-if="indicePathData.length > 0")
      template(v-for="(item, index) in indicePathData")
        span {{ item }}
        span.mx-1(v-if="!lastIndice(index)") &gt;
  div.mt-2.list_body_fields(v-if="hasBodyFields")
    div(v-for="field in bodyFields")
      span.label
        strong
          | {{ field.label }}
      span.colon
        | : 
      span.value(v-html="field.values[0]")
  div.mt-2(
    v-if="documentCardAsunto && documentCardAsunto.values.length > 0"
    data-cy="document_card_asunto"
  )
    span
      strong {{t("components.documents.metadata.asunto")}}
      | {{ documentCardAsunto.values[0] }}
</template>

<script>
  import mixins from 'common/mixins.js'
  import filters from 'common/filters.js'

  export default {
    props: {
      fields: { type: Array, default: () => [] },
      searchAttributes: { type: Object, default: () => { return {} } }
    },
    computed: {
      vocesText(){
        if (!this.showConcepts) return ''

        const maxLength = 250
        const vocesMetadata = this.fields.find(field => field.id == 'voces_string')
        const text = vocesMetadata ? vocesMetadata.values.map(elem => elem.label).join(', ') : ''
        return this.$options.filters.limit_string_length(text, maxLength)
      },
      themineConceptsData(){
        if (!this.showConcepts) return ''

        const themineMetadatas = this.fields.filter(field =>
          (field.id.endsWith('_mb') && field.id != 'a-favor-o-en-contra_mb')
        )
        const elementsToShowPerGroup = 3
        const themine_result = themineMetadatas.map(themineMetadata =>
          themineMetadata.values.slice(0, elementsToShowPerGroup).map(elem => elem.label).join(', ')
        )

        const favor_contra_metadata = this.fields.find(field =>
          field.id == 'a-favor-o-en-contra_mb'
        )
        if (favor_contra_metadata){
          const favor_contra_text = favor_contra_metadata.values.map(elem => elem.label).join(', ')
          themine_result.push(favor_contra_text)
        }
        return themine_result
      },
      indicePathData(){
        if (!this.showIndicePath) return []

        const indicesMetadata = this.fields.find(field => field.id == 'indices_path')
        if (indicesMetadata)
          return indicesMetadata.values.map(item => item.label);
        return []
      },
      showConcepts(){
        return this.searchAttributes.search_type == 'jurisprudencia' && gon.paisiso == 'esp'
      },
      showTags(){
        return this.searchAttributes.search_type == 'formularios' && gon.paisiso == 'esp'
      },
      showIndicePath(){
        return this.searchAttributes.search_type == 'esquemas' && gon.paisiso == 'esp'
      },
      tagValues() {
        var hubs = this.fields.find(field => field.id == 'themine_global_hub_mb')
        return hubs ? hubs.values : []
      },
      bodyFields() {
        return this.fields.filter(field => ['supuesto', 'normativa'].includes(field.id))
      },
      hasBodyFields() {
        return this.bodyFields.length > 0
      },
      documentCardAsunto() {
        if (!this.hasDocumentCardData)
          return ''

        return this.documentCard.values.find(field => field.id == 'asunto')
      },
      documentCard() {
        return this.fields.find(field => field.id == 'document_card')
      },
      hasDocumentCardData() {
        return this.documentCard && this.documentCard.values.length > 0
      }
    },
    methods: {
      lastConcept(index) {
        return index === this.themineConceptsData.length - 1
      },
      label_class(value) {
        if (value.extra && value.extra.ambito_hub) {
          return `metadataLabel-${value.extra.ambito_hub.toLowerCase()}`
        } else {
          return `metadataLabel-${value.label.toLowerCase()}`
        }
      },
      lastIndice(index) {
        return index === this.indicePathData.length - 1
      }
    },
    filters: {
      titleize_label: filters.titleize_label,
      limit_string_length: filters.limit_string_length
    },
    mixins: [mixins.translate]
  }
</script>
